import { connect } from "react-redux"
import LayoutList from "./LayoutList"
import { withRouter } from "react-router"
import { compose } from "redux"
import { setLayoutListSort } from "store/actions/reduxActions"
import { filterRows, sortRows } from "utils/table"

function createData(layoutDetails) {
	return Object.values(layoutDetails).map((layout) => {
		const {
			id,
			// published,
			name,
			ownerName,
			state,
		} = layout
		return {
			id,
			published: true,
			layoutName: name || "Not Named",
			ownerName,
			state,
		}
	})
}

const columns = [
	{
		width: 120,
		flexGrow: 1.0,
		label: "Select",
		dataKey: "checkbox",
		numeric: false,
		disableSort: true,
	},
	{
		width: 200,
		flexGrow: 1.0,
		label: "Layout Name",
		dataKey: "layoutName",
		numeric: false,
		disableSort: false,
	},
	{
		width: 120,
		flexGrow: 1.0,
		label: "Owner",
		dataKey: "ownerName",
		numeric: false,
		disableSort: false,
	},
	{
		width: 120,
		flexGrow: 1.0,
		label: "State",
		dataKey: "state",
		numeric: false,
		disableSort: false,
	},
]

const getRows = (layoutDetails, filter, sortBy, sortDirection) => {
	let rows = createData(layoutDetails)
	if (filter !== "") {
		rows = filterRows(rows, filter)
	}
	if (sortBy && sortDirection) {
		rows = sortRows(rows, sortBy, sortDirection)
	}
	return rows
}

const mapStateToProps = (state) => ({
	rows: getRows(
		state.layoutDetails,
		state.layoutListFilter,
		state.layoutListSort.sortBy,
		state.layoutListSort.sortDirection,
	),
	columns,
	sortBy: state.layoutListSort["sortBy"],
	sortDirection: state.layoutListSort["sortDirection"],
	userPrivileges: state.user.privileges,
	siteView: state.siteView,
})

const mapDispatchToProps = (dispatch) => ({
	handleSortClick: (sortObject) => dispatch(setLayoutListSort(sortObject.sortBy, sortObject.sortDirection)),
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(LayoutList)
